/* Coria · trecere UX cos + cautare: nume accesibile pentru controalele care nu au (doar atribute, nimic vizual).
   Sertarul se re-randeaza prin AJAX: reaplicam la evenimentele de cos si la schimbari in sertar (observator doar pe sertar). */
(function () {
  'use strict';
  if (window.__cfUxCos) return; window.__cfUxCos = 1;
  function name(sel, label) {
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) {
      var e = els[i];
      if (!e.getAttribute('aria-label') && !(e.labels && e.labels.length)) e.setAttribute('aria-label', label);
    }
  }
  function apply() {
    /* tara/judetul/codul postal au eticheta direct in snippets/shipping-calculator.liquid */
    name('.cart--note-close', 'Închide nota de comandă');
    name('.search-tab-button', 'Caută');
  }
  var t = 0;
  function later() { if (!t) t = setTimeout(function () { t = 0; apply(); }, 150); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  ['cart:updated', 'cart:refresh', 'cart:open', 'cart-drawer:open'].forEach(function (e) { document.addEventListener(e, later); });
  function watch() {
    var d = document.querySelector('cart-drawer');
    if (d && window.MutationObserver) new MutationObserver(later).observe(d, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();

/* Coria · 19.10.2026: sertarul cosului ca dialog accesibil de la tastatura (de lipit la finalul assets/coria-ux-cos.js).
   Tema il deschide prin clase (.show pe cart-drawer, cu ~1,2 s intarziere dupa „Adauga in cos”) si il re-randeaza prin AJAX
   (innerHTML), deci: atributele de dialog stau pe cart-drawer (nu se pierd), restul se reaplica la fiecare schimbare.
   - role=dialog + aria-modal + aria-labelledby pe titlul „Cosul tau”;
   - la deschidere focusul intra pe „Inchide cosul”; Tab/Shift+Tab raman in sertar (bara fixa e aria-hidden, butonul real ramane);
   - Esc inchide prin butonul real (acelasi drum ca un click) si focusul revine pe butonul care l-a deschis;
   - subtotalul si comanda minima se anunta intr-o regiune role=status din afara continutului re-randat. */
(function () {
  'use strict';
  if (window.__cfCosDlg) return; window.__cfCosDlg = 1;
  var opener = null, lastOut = null, wasOpen = false, said = '', st = 0;
  function cd() { return document.querySelector('cart-drawer'); }
  function isOpen(d) { return !!(d && d.classList.contains('show') && d.style.display !== 'none' && d.getClientRects().length); }
  function focusables(d) {
    return [].slice.call(d.querySelectorAll('a[href],button:not([disabled]),input:not([type=hidden]):not([disabled]),select:not([disabled]),textarea:not([disabled]),summary,[tabindex]:not([tabindex="-1"])'))
      .filter(function (e) { return e.tabIndex >= 0 && e.getClientRects().length && getComputedStyle(e).visibility !== 'hidden' && !e.closest('[inert],[aria-hidden="true"]'); });
  }
  function live() {
    var r = document.getElementById('cf-cos-live');
    if (!r) {
      r = document.createElement('div'); r.id = 'cf-cos-live'; r.setAttribute('role', 'status'); r.setAttribute('aria-live', 'polite');
      r.style.cssText = 'position:absolute;width:1px;height:1px;margin:-1px;padding:0;border:0;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap';
      document.body.appendChild(r);
    }
    return r;
  }
  function summary(d) {
    var a = d.querySelector('.cart-summary-price-amount'), n = d.querySelector('[data-cart-items]'), b = d.querySelector('#cartCheckout');
    if (!a) return d.querySelector('.drawer__inner-empty, .cart--empty, [class*=empty-cart]') || /is-empty/.test(d.className) ? 'Coșul este gol.' : '';
    var s = 'Subtotal ' + a.textContent.trim().replace(/\s+/g, ' ');
    if (n && n.dataset.cartItems) s = n.dataset.cartItems + (n.dataset.cartItems === '1' ? ' produs' : ' produse') + ', ' + s;
    if (b && b.disabled) { var m = d.querySelector('.cf-cosbar__t'); s += '. ' + (m && /minim/i.test(m.textContent) ? m.textContent.trim() : 'Comanda minimă nu este atinsă'); }
    return s;
  }
  function attrs(d) {
    d.setAttribute('role', 'dialog'); d.setAttribute('aria-modal', 'true');
    var h = d.querySelector('.cart--drawer-heading');
    if (h) { if (!h.id) h.id = 'cf-cos-titlu'; d.setAttribute('aria-labelledby', h.id); }
    else if (!d.getAttribute('aria-label')) d.setAttribute('aria-label', 'Coșul tău');
  }
  function sync() {
    st = 0; var d = cd(); if (!d) return;
    attrs(d);
    var open = isOpen(d);
    if (open && !wasOpen) {
      opener = lastOut;
      /* tema poate muta singura focusul pe .drawer__inner la transitionend, iar butonul „Adauga in cos” isi ia focusul inapoi
         cand ii dispare rotita: il punem pe „Inchide” doar daca e inca afara, si mai verificam o data dupa rotita */
      [300, 1300].forEach(function (ms) { setTimeout(function () { var x = cd(); if (isOpen(x) && !x.contains(document.activeElement)) { var c = x.querySelector('[data-drawer-close]') || focusables(x)[0]; if (c) c.focus(); } }, ms); });
    }
    if (!open && wasOpen) {
      if (opener && document.contains(opener) && opener.getClientRects().length && (!document.activeElement || document.activeElement === document.body || d.contains(document.activeElement))) opener.focus();
      opener = null; said = '';
    }
    if (open) { var s = summary(d); if (s && s !== said) { said = s; live().textContent = s; } }
    /* „+”, „−”, „Elimina” re-randeaza sertarul (innerHTML): butonul apasat dispare si focusul cadea pe BODY.
       Il punem inapoi pe controlul cu acelasi nume (aceeasi linie), altfel pe primul control ramas, altfel pe „Inchide”. */
    if (open && wasOpen && lastIn && !document.contains(lastIn) && (!document.activeElement || document.activeElement === document.body)) {
      var f = focusables(d), back = null;
      for (var i = 0; i < f.length && !back; i++) if (f[i].tagName === lastIn.tagName && (f[i].getAttribute('aria-label') || '') === lastKey && lastKey) back = f[i];
      back = back || d.querySelector('cart-drawer-items :is(button, input, a[href])') || d.querySelector('[data-drawer-close]');
      if (back) back.focus();
    }
    wasOpen = open;
  }
  function later() { if (!st) st = setTimeout(sync, 120); }
  var lastIn = null, lastKey = '';
  document.addEventListener('focusin', function (e) {
    var d = cd(); if (!d) return;
    if (!d.contains(e.target)) lastOut = e.target;
    else { lastIn = e.target; lastKey = e.target.getAttribute('aria-label') || ''; }
  }, true);
  document.addEventListener('keydown', function (e) {
    var d = cd(); if (!isOpen(d)) return;
    if (e.key === 'Escape') {
      var c = d.querySelector('[data-drawer-close]');
      if (c) { e.preventDefault(); e.stopPropagation(); c.click(); later(); }
      return;
    }
    if (e.key !== 'Tab') return;
    var f = focusables(d); if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    /* la capete mutam noi focusul si oprim evenimentul, ca vechea capcana a temei (cu lista calculata la deschidere) sa nu sara in alta parte */
    var to = !d.contains(a) ? (e.shiftKey ? last : first) : (!e.shiftKey && a === last) ? first : (e.shiftKey && a === first) ? last : null;
    if (to) { e.preventDefault(); e.stopPropagation(); to.focus(); }
  }, true);
  function watch() {
    var d = cd(); if (!d || !window.MutationObserver) return;
    new MutationObserver(later).observe(d, { attributes: true, attributeFilter: ['class', 'style'], childList: true, subtree: true, characterData: true });
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();
